/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { priceDataReducer } from './reducers/index'

export const priceData = filterActions(priceDataReducer, Object.values(constants))
